import { formatCurrency, formatTimestamp } from "../../utils/format";

function buildColumns(currency, rate) {
  const hasRate = currency === "GBP" || (typeof rate === "number" && !isNaN(rate));

  const convert = (gbpAmount) => {
    if (currency === "GBP") return gbpAmount;
    return hasRate ? gbpAmount * rate : null;
  };

  const money = (amount) => (amount === null ? "—" : formatCurrency(amount, currency));

  return [
    { key: "timestamp", label: "Timestamp", render: (o) => formatTimestamp(o.timestamp) },
    { key: "orderId", label: "Order ID" },
    { key: "country", label: "Country" },
    { key: "currency", label: "Currency" },
    { key: "product", label: "Product" },
    { key: "variant", label: "Variant" },
    // Left to right as the arithmetic runs: list price less the discount is
    // what was paid, then each deduction in turn down to the payout.
    { key: "rrp", label: `RRP (${currency})`, render: (o) => money(convert(o.rrpGbp)) },
    {
      key: "discount",
      label: `Discount (${currency})`,
      render: (o) => money(convert(o.discountGbp)),
    },
    { key: "paid", label: `Paid (${currency})`, render: (o) => money(convert(o.paidGbp)) },
    // Which of the two above the contract reckoned on. Shown beside them
    // rather than instead of them: where base and RRP differ, that gap is
    // the discount the vendor is sharing.
    { key: "base", label: `Base (${currency})`, render: (o) => money(convert(o.base)) },
    { key: "vat", label: `VAT (${currency})`, render: (o) => money(convert(o.vat)) },
    { key: "frame", label: `Frame (${currency})`, render: (o) => money(convert(o.frame)) },
    { key: "netRevenue", label: `Net (${currency})`, render: (o) => money(convert(o.netRevenue)) },
    { key: "payout", label: `Payout (${currency})`, render: (o) => money(convert(o.payout)) },
  ];
}

export default function OrdersTable({ orders, currency = "GBP", rate = 1 }) {
  if (orders.length === 0) {
    return (
      <p className="font-mono text-xs uppercase tracking-widest text-collectors-gray py-6">
        No orders in this time range.
      </p>
    );
  }

  const columns = buildColumns(currency, rate);

  return (
    <div className="overflow-x-auto border border-solid border-collectors-black">
      <table className="w-full border-collapse">
        <thead>
          <tr className="border-b border-solid border-collectors-black">
            {columns.map((col) => (
              <th
                key={col.key}
                className="text-left px-3 py-2 font-mono text-[11px] uppercase tracking-wider whitespace-nowrap"
              >
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {orders.map((order, index) => (
            <tr
              key={`${order.orderId}-${order.timestamp}-${index}`}
              className="border-b border-solid border-collectors-light last:border-b-0"
            >
              {columns.map((col) => (
                <td key={col.key} className="px-3 py-2 font-mono text-xs whitespace-nowrap">
                  {col.render ? col.render(order) : order[col.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}